import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LeadCaptureForm from "../components/LeadCaptureForm";

export default function Newsletter() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-20" data-testid="newsletter-page">
        <LeadCaptureForm />
      </main>
      <Footer />
    </div>
  );
}
